import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { searchFiles } from "../../../graphql/queries";
import { updateFile } from "../../../graphql/mutations";

import { Dialog, Grid, Link, Typography } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import {
  ArrayField,
  ArrayInput,
  Button,
  ChipField,
  Confirm,
  FileInput,
  FormDataConsumer,
  ImageInput,
  required,
  SingleFieldList,
  SimpleFormIterator,
  TextInput,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import { MAX_PHOTO_SIZE, MAX_PHOTO_SIZE_MSG } from "../../../utils/constants";
import {
  AttachFileIcon,
  AttachPhotoIcon,
  RemoveIcon,
} from "../../../components/common/iconography";
import { ImageField } from "../../../components/common/ImageField";
import { logError } from "../../../utils/appUtils";
import { FileField } from "../../../components/common/FileField";
import { handleFileChange } from "../../../utils/fileUtils";

const useStyles = makeStyles((theme) => ({
  removeButton: {},
  array: {
    marginTop: theme.spacing(1),
  },
}));

const validateUnicity = (value, allValues) => {
  const allCategories = allValues.fileCategories || [];

  if (value && allCategories) {
    const duplicates = allCategories.filter(
      (item) =>
        item?.name?.toLowerCase().replace(/\s/g, "") ===
        value.toLowerCase().replace(/\s/g, ""),
    ).length;

    if (duplicates > 1) {
      // return an object just like the other validators
      return { message: "Duplicate entry" };
    }
  }
  return undefined;
};

const validateCategory = [required(), validateUnicity];

const DeepRemoveButton = (props) => {
  const form = useForm();
  const notify = useNotify();
  var n = props.className.lastIndexOf("-");
  var index = Number(props.className.substring(n + 1));
  const fieldState = form.getFieldState("fileCategories");
  const data = fieldState ? fieldState.value[index] : undefined;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleRemove = async (event) => {
    if (data?.key) {
      try {
        setLoading(true);
        const searchInput = {
          sort: { field: "displayName", direction: "asc" },
          filter: {
            reloadYardId: { eq: window.appUser.reloadYardId },
            category: { eq: data.key },
          },
          limit: 500,
        };
        const response = await API.graphql(
          graphqlOperation(searchFiles, searchInput),
        );
        let documents = response.data.searchFiles.items;
        debugger;

        if (documents?.length > 0) {
          const results = await Promise.allSettled(
            documents.map((item) => {
              const input = { ...item };
              input.category = null;
              delete input.createdAt;
              delete input.updatedAt;

              return API.graphql(graphqlOperation(updateFile, { input }));
            }),
          );

          debugger;
          const resError = results.find((itm) => itm.status === "rejected");
          if (resError) throw resError.reason;
        }

        props.onClick(event);
        notify("Documents successfully de-categorized.");
      } catch (err) {
        logError("AttachmentsTab:DeepRemoveButton:handleRemove", err, notify);
      }
    } else props.onClick(event);

    setOpen(false);
    setLoading(false);
  };

  return (
    <>
      <Button
        label="Remove"
        color="default"
        onClick={data?.key ? handleDialogOpen : handleRemove}
        disabled={loading}
      >
        <RemoveIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={"Delete Confirmation"}
        content={
          "Removing a Category will immediatelly mark related documents as Uncategorized. Are you sure you want to delete this Category? "
        }
        onConfirm={handleRemove}
        onClose={handleDialogClose}
      />
    </>
  );
};

const DocumentsPanel = ({ disabled, ...props }) => {
  if (disabled) return <DocumentsShow {...props} />;
  return <DocumentsForm {...props} />;
};

const DocumentsForm = (props) => {
  const classes = useStyles();
  const form = useForm();
  const notify = useNotify();
  const [magnifiedUrl, setMagnifiedUrl] = useState();

  const handleImageChange = (value, source) => {
    debugger;
    if (!value) {
      form.change(source, null);
    } else if (value?.size > MAX_PHOTO_SIZE) {
      form.change(source, null);
      notify(MAX_PHOTO_SIZE_MSG, "warning");
    }
  };

  const handleMagnifyPhoto = (event) => {
    debugger;
    if (!magnifiedUrl) setMagnifiedUrl(event.target.lowsrc);
    else setMagnifiedUrl(null);
  };

  return (
    <Grid container direction="row" spacing={3}>
      <Grid item xs={12}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          Instructions
        </Typography>
        <ol>
          <li>
            {" "}
            Download{" "}
            <Link
              href="https://transloads.co/docs/customizing-docx-document-templates"
              target="_blank"
              rel="noreferrer"
              underline="hover"
            >
              document template
            </Link>
            .
          </li>
          <li>
            {" "}
            Customize following the instructinos and excamples on the download
            page{" "}
          </li>
          <li> Save as a .docx file and upload here </li>
          <li>
            {" "}
            If errors are found, review, correct the errors and re-upload{" "}
          </li>
          <li> For help, contact us at 877-TRANSLOAD / 877-872-6756 </li>
        </ol>
      </Grid>
      <Grid item xs={12} md={6}>
        <FileInput
          source="receiptTemplate"
          label="INBOUND RECEIPT TEMPLATE"
          variant="outlined"
          fullWidth
          placeholder={
            <p>
              <AttachFileIcon fontSize="large" /> <br /> Drop a DOCX file to
              upload, or click to select it.
            </p>
          }
          accept=".docx"
          onChange={(value) =>
            handleFileChange("receiptTemplate", value, form, notify)
          }
        >
          <FileField source="src" title="title" target="_blank" />
        </FileInput>
      </Grid>
      <Grid item xs={12} md={6}>
        <FileInput
          source="bolTemplate"
          label="BILL OF LADING TEMPLATE"
          variant="outlined"
          fullWidth
          placeholder={
            <p>
              <AttachFileIcon fontSize="large" /> <br /> Drop a DOCX file to
              upload, or click to select it.
            </p>
          }
          accept=".docx"
          onChange={(value) =>
            handleFileChange("bolTemplate", value, form, notify)
          }
        >
          <FileField source="src" title="title" target="_blank" />
        </FileInput>
      </Grid>
      <Grid item xs={12}>
        <ImageInput
          source="mapImage"
          label="YARD MAP"
          accept="image/*"
          variant="outlined"
          fullWidth
          placeholder={
            <p>
              <AttachPhotoIcon fontSize="large" /> <br /> Drop your map image
              here, or click to select it
            </p>
          }
          onChange={(value) => handleImageChange(value, "mapImage")}
        >
          <ImageField
            source="src"
            title="displayName"
            thumbWidth={512}
            thumbHeight={512}
            scaleThumb={true}
            fullSize={window.innerWidth}
            onClick={handleMagnifyPhoto}
          />
        </ImageInput>
        {magnifiedUrl ? (
          <Dialog
            open={magnifiedUrl}
            maxWidth="lg"
            onClick={handleMagnifyPhoto}
          >
            <img
              src={magnifiedUrl}
              alt="Yard Map"
              className={classes.mediaFull}
              onClick={handleMagnifyPhoto}
            />
          </Dialog>
        ) : null}
      </Grid>
      <Grid item xs={12} md={6}>
        <ArrayInput
          source="fileCategories"
          label="DOCUMENT CATEGORIES"
          fullWidth
          className={classes.array}
        >
          <SimpleFormIterator removeButton={<DeepRemoveButton />}>
            <FormDataConsumer>
              {({
                formData,
                scopedFormData, // The data for this item of the ArrayInput
                getSource, // Function to get the valid source inside an ArrayInput. Translates to "inventories.items[].property"
                ...rest
              }) => (
                <TextInput
                  source={getSource("name")}
                  label="Category Name"
                  variant="outlined"
                  fullWidth
                  validate={validateCategory}
                  helperText={false}
                />
              )}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  );
};

const DocumentsShow = (props) => {
  const classes = useStyles();
  const [magnifiedUrl, setMagnifiedUrl] = useState();

  const handleMagnifyPhoto = (event) => {
    debugger;
    if (!magnifiedUrl) setMagnifiedUrl(event.target.lowsrc);
    else setMagnifiedUrl(null);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          RECEIPT TEMPLATE
        </Typography>
        <FileField source="receiptTemplate" label="Receipt Template" />
      </Grid>
      <Grid item xs={6}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          BOL TEMPLATE
        </Typography>
        <FileField source="bolTemplate" label="BOL Template" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          YARD MAP
        </Typography>
        <ImageField
          source="mapImage"
          label="YARD MAP"
          thumbWidth={512}
          thumbHeight={512}
          scaleThumb={true}
          fullSize={window.innerWidth}
          onClick={handleMagnifyPhoto}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          DOCUMENT CATEGORIES
        </Typography>
        <ArrayField
          source="fileCategories"
          variant="outlined"
          fullWidth
          className={classes.chips}
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" />
          </SingleFieldList>
        </ArrayField>
      </Grid>
      <Grid item xs={12}>
        <Typography gutterBottom> </Typography>
        {magnifiedUrl ? (
          <Dialog
            open={magnifiedUrl}
            maxWidth="lg"
            onClick={handleMagnifyPhoto}
          >
            <img
              src={magnifiedUrl}
              alt="Yard Map"
              className={classes.mediaFull}
              onClick={handleMagnifyPhoto}
            />
          </Dialog>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default DocumentsPanel;
